/* eslint-disable react-hooks/exhaustive-deps */
import {Link} from 'react-router-dom'
import {useLayout} from '../../core'
import {Navbar} from './Navbar'
import BrandLogo from '../../../assets/media/uProcureLogo.png'

export function HeaderWrapper() {
  const {config} = useLayout()

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div id='kt_app_header' className='flex h-20 w-full min-w-0 items-center bg-white px-4'>
      <div className='flex w-full min-w-0 items-center'>
        {config.app.sidebar?.display && (
          <div className='flex items-center lg:hidden mr-2'>
            <button
              className='p-2 rounded-lg text-gray-500 hover:bg-gray-100'
              id='kt_app_sidebar_mobile_toggle'
            >
              <img src='/media/icons/duotune/abstract/abs015.svg' alt='menu' className='w-5 h-5' />
            </button>
            <Link to='/dashboard' className='ml-2 lg:hidden'>
              <img className='h-8' src={BrandLogo} alt='uProcure' />
            </Link>
          </div>
        )}

        {!config.app.sidebar?.display && (
          <Link to='/dashboard' className='mr-4'>
            <img className='h-8' src={BrandLogo} alt='uProcure' />
          </Link>
        )}

        <div className='flex min-w-0 flex-1 items-center'>
          <Navbar />
        </div>
      </div>
    </div>
  )
}
